const cnpjValidator = (cnpj: string): boolean => {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj.length !== 14) {
    return false;
  }

  let totalLength = cnpj.length - 2;
  let cnpjWithoutDigits = cnpj.substring(0, totalLength);
  const verifyingDigits = cnpj.substring(totalLength);

  let sum = 0;
  let position = totalLength - 7;
  for (let i = totalLength; i >= 1; i--) {
    sum += parseInt(cnpjWithoutDigits.charAt(totalLength - i)) * position--;
    if (position < 2) {
      position = 9;
    }
  }

  let result = 0;
  if (sum % 11 < 2) {
    result = 0;
  } else {
    result = 11 - (sum % 11);
  }

  if (result !== parseInt(verifyingDigits.charAt(0))) {
    return false;
  }

  totalLength++;
  cnpjWithoutDigits = cnpj.substring(0, totalLength);
  sum = 0;
  position = totalLength - 7;
  for (let i = totalLength; i >= 1; i--) {
    sum += parseInt(cnpjWithoutDigits.charAt(totalLength - i)) * position--;
    if (position < 2) {
      position = 9;
    }
  }

  result = 0;
  if (sum % 11 < 2) {
    result = 0;
  } else {
    result = 11 - (sum % 11);
  }

  if (result !== parseInt(verifyingDigits.charAt(1))) {
    return false;
  }

  return true;
};

export { cnpjValidator };
